import iziToast from "izitoast";
import 'izitoast/dist/css/iziToast.min.css'

// Global toast function
window.$toast = function (message, type, title) {
    const config = {
        position: 'topCenter',
        title: title ||  type.charAt(0).toUpperCase() + type.slice(1) + ' !!',
        message,
        progressBar: true,
        pauseOnHover: true,
    };
    iziToast[type](config);
}
